import React, { useEffect } from 'react';
import Head from 'next/head';
import Layout from '../components/layout';
import Container from '../components/container';
import NavBar from '../components/navbar';
import config from '../lib/config';

import { GetStaticProps } from 'next';
import { fetchAPI, getPrimaryMenuItems } from '../lib/api';
import { H2 } from '../components/text';
import { ISponsor } from '../models/sponsor';
import { IPage } from '../models/page';
import { IMenuItem } from '../models/menu-item';
import { VideoCategorySlider } from '../components/video-category-slider';
import { ICategoryVideo } from '../models/category-video';
import { LinkButton } from '../components/link-button';
import 'swiper/css';

interface IProps {
	primaryMenuItems: IMenuItem[];
	pageData: IPage;
	sponsors: ISponsor[];
}

export default function SummariesPage({ primaryMenuItems, pageData: { page }, sponsors }: IProps) {
	const pageTitle = `${page.title} | ${config.siteName}`;
	const meta = page.seo?.description || page.title;
	const containerRef = React.useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (containerRef.current) {
			const script = document.createElement('script');
			script.src = 'https://ced.bbvms.com/ch/1114.js';
			script.async = true;
			script.textContent = 'console.log("Script 1114 loaded");';

			// Append to container
			containerRef.current.appendChild(script);

			// Cleanup function to remove script when component unmounts
			return () => {
				if (containerRef.current && script.parentNode === containerRef.current) {
					containerRef.current.removeChild(script);
				}
			};
		}
	}, []);

	return (
		<Layout preview customClass="bg-kkd-dark" sponsors={sponsors} metaTitle={pageTitle} metaDesc={meta}>
			<Head>
				<title>{pageTitle}</title>
			</Head>
			<NavBar items={primaryMenuItems} />
			<Container className="py-12">
				<div className="bbvms-container" ref={containerRef}></div>
			</Container>
		</Layout>
	);
}

export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
	const primaryMenuItems = await getPrimaryMenuItems();
	const pageData = await fetchAPI<{ sponsors: { nodes: any[] } }>(`
		query {
			page(id: 112008, idType: DATABASE_ID) {
				title
				content
			}
			sponsors(first: 20) {
				nodes {
					title
					sponsor_fields {
						subtitle
						websiteUrl
						mainSponsor
						invertedImage {
							sourceUrl
						}
					}
				}
			}
		}
	`);

	return {
		revalidate: 300,
		props: {
			sponsors: pageData.sponsors.nodes,
			pageData,
			preview,
			primaryMenuItems,
		},
	};
};
